export default __webpack_public_path__ + "static/media/sugg1144.3d24eb98.png";